import React from "react";
import { ChooseUsCard } from "../../../intro/components/landing-new";
import { AURORA_THEME } from "./theme";

// Dark-mode wrapper for the "Why choose us" reasons grid. Reuses ChooseUsCard
// (image-backed, looks fine on dark surfaces) but skips the shared WhyChooseUs
// container which hardcodes a white background.

const AuroraReasonsGrid = ({ title, description, reasons }) => {
  return (
    <section
      className="tw-relative tw-w-full tw-py-12 md:tw-py-16"
      style={{ backgroundColor: AURORA_THEME.bg.primary }}
    >
      <div className="tw-mx-auto tw-max-w-6xl tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <div className="tw-mb-10 tw-text-center">
          <h2
            className="tw-text-2xl tw-font-extrabold md:tw-text-3xl"
            style={{ color: AURORA_THEME.text.primary }}
          >
            {title}
          </h2>
          <p
            className="tw-mt-2 tw-text-sm md:tw-text-base"
            style={{ color: AURORA_THEME.accent.primary }}
          >
            {description}
          </p>
        </div>
        <div className="tw-grid tw-gap-6 md:tw-grid-cols-3">
          {reasons.map((card, idx) => (
            <ChooseUsCard
              key={card.key || card.title || idx}
              {...card}
              mobileVariant="vertical"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AuroraReasonsGrid;
